module.exports = __webpack_public_path__ + "img/usa-cancer-male.08b0f8e7.png";